import { useCallback, useEffect, useState } from 'react';

import { collapseEventTarget, COLLAPSE_STATE_CHANGED, readCollapseStates, writeCollapseState } from './collapseStorage';

export const useCollapseState = (storageKey, sectionId, defaultOpen) => {
  const [isOpen, setIsOpenState] = useState(() => {
    const states = readCollapseStates(storageKey);
    if (states !== null && sectionId in states) {
      return states[sectionId];
    }
    return defaultOpen;
  });

  useEffect(() => {
    const handleChange = event => {
      const { storageKey: key, sectionId: id, isOpen: value } = event.detail;
      if (key === storageKey && id === sectionId) {
        setIsOpenState(value);
      }
    };
    collapseEventTarget.addEventListener(COLLAPSE_STATE_CHANGED, handleChange);
    return () => collapseEventTarget.removeEventListener(COLLAPSE_STATE_CHANGED, handleChange);
  }, [storageKey, sectionId]);

  const setIsOpen = useCallback(
    updater => {
      setIsOpenState(prev => {
        const next = typeof updater === 'function' ? updater(prev) : updater;
        writeCollapseState(storageKey, sectionId, next);
        return next;
      });
    },
    [storageKey, sectionId]
  );

  return [isOpen, setIsOpen];
};
